import React, { useState } from "react";

import { Button, Grid, IconButton, TextField } from "@material-ui/core";
import {
  AddCircle as AddCircleIcon,
  Delete as DeleteIcon,
} from "@material-ui/icons";

export default function Sizes({ form: { getFieldDecorator }, sizes }) {
  const [adUnitsSizes, setAdUnitsSizes] = useState([...sizes]);

  const handlePlus = () => {
    setAdUnitsSizes(adUnitsSizes => [...adUnitsSizes, { size: [0, 0] }]);
  };

  const handleTrash = index => {
    const newSizes = [...adUnitsSizes];
    newSizes.splice(index, 1);
    setAdUnitsSizes(adUnitsSizes => [...newSizes]);
  };

  return (
    <>
      <Grid spacing={1} container item xs={12} justify="flex-end">
        <Button
          style={{ marginTop: 20, width: "30%" }}
          color="primary"
          variant="outlined"
          startIcon={<AddCircleIcon />}
          onClick={handlePlus}
        >
          Add new size
        </Button>
      </Grid>
      {adUnitsSizes.map((size, index) => (
        <div key={index}>
          <Grid spacing={1} container item xs={12}>
            <Grid item xs={5}>
              {getFieldDecorator(`column1[${index}]`, {
                initialValue: size.size[0] ? size.size[0].toString() : "",
                rules: [
                  {
                    required: true,
                    message: "Please input your widht!",
                    whitespace: true,
                  },
                ],
              })(
                <TextField
                  id="widht"
                  label="width"
                  color="primary"
                  fullWidth
                  style={{ marginTop: 13 }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  placeholder="width"
                  type="number"
                />,
              )}
            </Grid>

            <Grid item xs={5}>
              {getFieldDecorator(`column2[${index}]`, {
                initialValue: size.size[1] ? size.size[1].toString() : "",
                rules: [
                  {
                    required: true,
                    message: "Please input your height!",
                    whitespace: true,
                  },
                ],
              })(
                <TextField
                  id="height"
                  label="height"
                  color="primary"
                  fullWidth
                  style={{ marginTop: 13 }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  placeholder="height"
                  type="number"
                />,
              )}
            </Grid>

            <Grid item xs={2}>
              {adUnitsSizes.length !== 1 && (
                <IconButton
                  aria-label="delete"
                  style={{ marginTop: 13, width: "100%" }}
                  onClick={() => handleTrash(index)}
                >
                  <DeleteIcon color="primary" />
                </IconButton>
              )}
            </Grid>
          </Grid>
        </div>
      ))}
    </>
  );
}
